const secondaryNavLinks = document.querySelectorAll('.secondary-nav__link, .scroll-to-section');

if (secondaryNavLinks.length) {
  const navList = document.querySelector('.secondary-nav');
  const navListBody = document.querySelector('.secondary-nav__list');

  const sectionElements = {};
  secondaryNavLinks.forEach((link) => {
    const linkId = link.getAttribute('href');
    if (linkId && linkId !== '#') {
      sectionElements[linkId] = document.querySelector(linkId.startsWith('http') ? `[href="${linkId}"]` : linkId);
    }
  });

  // const updateURL = (linkId) => {
  //   if (window.location.hash !== linkId) {
  //     history.replaceState(null, null, linkId);
  //   }
  // };

  const scrollToSection = (sectionElem) => {
    const { top } = sectionElem.getBoundingClientRect();
    const currentScroll = window.pageYOffset;
    const sectionTop = sectionElem.getBoundingClientRect().top + currentScroll;
    const isScrollingDown = sectionTop > currentScroll;

    const headerHeight = isScrollingDown ? 0 : getHeaderHeight();

    window.scrollTo({
      top: top + window.pageYOffset - headerHeight - (navList?.offsetHeight ?? 0),
      behavior: 'smooth',
    });
  };

  const initScrollTriggers = () => {
    secondaryNavLinks.forEach((link) => {
      const linkId = link.getAttribute('href');
      const sectionElem = sectionElements[linkId];

      if (sectionElem) {
        gsap.timeline({
          scrollTrigger: {
            trigger: sectionElem,
            start: 'top 140',
            end: 'bottom 180',
            scrub: true,
            onToggle: (self) => {
              if (self.isActive) {
                // updateURL(linkId);

                if (windowWidth() <= breakpointMd) {
                  const scrollPos =
                    link.offsetLeft - (navListBody?.offsetWidth ?? 0) / 2 + (link?.offsetWidth ?? 0) / 2;
                  navListBody?.scroll({
                    left: scrollPos,
                    behavior: 'smooth',
                  });
                }
              }
            },
            toggleClass: { targets: link, className: 'is-active' },
          },
        });
      }
    });
  };

  secondaryNavLinks.forEach((link) => {
    const linkId = link.getAttribute('href');
    const sectionElem = sectionElements[linkId];

    if (sectionElem) {
      link.addEventListener('click', (ev) => {
        ev.preventDefault();
        scrollToSection(sectionElem);
        // updateURL(linkId);
      });
    }
  });

  window.addEventListener('load', () => {
    setTimeout(initScrollTriggers, 0);
  });

  // Header Movement animation
  if (windowWidth() > breakpointMd) {
    const secondaryNavTrigger = document.querySelector('.secondary-nav__trigger');
    const siteHeader = document.querySelector('.site-header');
    CustomEase.create('customEase', '0.25, 1, 0.5, 1');

    const headerHeight = siteHeader.offsetHeight;
    const secondaryTopOffset = secondaryNavTrigger.getBoundingClientRect().top + window.pageYOffset;

    let lastScrollY = window.scrollY;
    let isHeaderHidden = false;

    window.addEventListener(
      'scroll',
      () => {
        const currentScrollY = window.scrollY;

        if (currentScrollY < secondaryTopOffset) {
          lastScrollY = currentScrollY;
          return;
        }

        if (Math.abs(currentScrollY - lastScrollY) < 10) return;

        const isScrollingDown = currentScrollY > lastScrollY;
        const shouldHideHeader = isScrollingDown && !isHeaderHidden;
        const shouldShowHeader = !isScrollingDown && isHeaderHidden;

        if (shouldHideHeader || shouldShowHeader) {
          isHeaderHidden = shouldHideHeader;

          const shouldHaveClass = !isHeaderHidden;
          if (document.body.classList.contains('secondary-scroll-up') !== shouldHaveClass) {
            document.body.classList.toggle('secondary-scroll-up', shouldHaveClass);
          }

          gsap.to(siteHeader, {
            top: isHeaderHidden ? -headerHeight : 0,
            duration: 0.3,
            ease: 'customEase',
          });
        }

        lastScrollY = currentScrollY;
      },
      { passive: true },
    );
  }
}
